import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { DetailedCitizenProceduresIndicatorC3Data } from "@/services/esus/indicator/esf/c3/getDetailedCitizensProceduresIndicatorC3";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { IndicatorEsfC3CitizensProceduresHistoryItem } from "./IndicatorEsfC3CitizensProceduresHistoryItem";
import { IndicatorEsfC3CitizensProceduresHistoryInfo } from "./IndicatorEsfC3CitizensProceduresHistoryInfo";

type IndicatorEsfC3CitizensProceduresHistoryProps = {
	citizenWithAttendanceProcedures: DetailedCitizenProceduresIndicatorC3Data;
};

export function IndicatorEsfC3CitizensProceduresHistory({
	citizenWithAttendanceProcedures,
}: Readonly<IndicatorEsfC3CitizensProceduresHistoryProps>) {
	const indicatorEsfC3CitizenHistoryInfo = {
		fullName: citizenWithAttendanceProcedures.fullName ?? "N/A",
		birthdate: citizenWithAttendanceProcedures.birthdate
			? dayjs(citizenWithAttendanceProcedures.birthdate).format("DD/MM/YYYY")
			: "N/A",
		document: citizenWithAttendanceProcedures.cpf
			? formatIdentifier(citizenWithAttendanceProcedures.cpf)
			: citizenWithAttendanceProcedures.cns ?? "",
		motherName: citizenWithAttendanceProcedures.motherName ?? "",
		phone: citizenWithAttendanceProcedures.phone
			? phoneFormat(citizenWithAttendanceProcedures.phone)
			: "",
		address:
			addressConcat(
				citizenWithAttendanceProcedures.street,
				citizenWithAttendanceProcedures.houseNumber,
				citizenWithAttendanceProcedures.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsfC3CitizensProceduresHistoryInfo {...indicatorEsfC3CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Exames/Procedimentos 3º Trimestre"
				timeLineContents={(
					citizenWithAttendanceProcedures.thirdTrimesterProcedures || []
				).map<TimeLineContent>((attendanceProcedure) => {
					return {
						content: (
							<IndicatorEsfC3CitizensProceduresHistoryItem
								attendanceProcedure={attendanceProcedure}
							/>
						),
						eventDate: attendanceProcedure.date
							? dayjs(attendanceProcedure.date).format("DD/MM/YYYY")
							: "N/A",
					};
				})}
			/>
			<TimeLine
				timeLineTitle="Exames/Procedimentos 1º Trimestre"
				timeLineContents={(
					citizenWithAttendanceProcedures.firstTrimesterProcedures || []
				).map<TimeLineContent>((attendanceProcedure) => {
					return {
						content: (
							<IndicatorEsfC3CitizensProceduresHistoryItem
								attendanceProcedure={attendanceProcedure}
							/>
						),
						eventDate: attendanceProcedure.date
							? dayjs(attendanceProcedure.date).format("DD/MM/YYYY")
							: "N/A",
					};
				})}
			/>
		</>
	);
}
